"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.archColors = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var archWidth = 216;
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      position: 'relative',
      overflow: "hidden"
    },
    bottom: {
      color: theme.palette.grey[200]
    },
    top: {
      animationDuration: '550ms',
      position: 'absolute',
      left: 0,
      top: 0
    },
    circle: {
      strokeLinecap: 'round'
    },
    arch: {
      transform: "rotate(180deg) !important"
    },
    error: {
      "& .MuiCircularProgress-svg": {
        color: theme.palette.error.main
      }
    },
    success: {
      "& .MuiCircularProgress-svg": {
        color: theme.palette.success.main
      }
    },
    warning: {
      "& .MuiCircularProgress-svg": {
        color: theme.palette.warning.main
      }
    }
  };
});
/**
 *
 * ** This module is used to display data in a meaningful and visual way. **
 *
 */

var Arch = function Arch(_ref) {
  var _classNames, _classNames2;

  var value = _ref.value,
      color = _ref.color;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: styles.root,
    style: {
      "height": archWidth / 2 + 2
    }
  }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
    value: 50,
    variant: "static",
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.bottom, true), _defineProperty(_classNames, styles.arch, true), _classNames)),
    classes: {
      circle: styles.circle
    },
    size: archWidth,
    thickness: 1
  }), /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
    value: value / 2,
    variant: "static",
    className: (0, _classnames.default)((_classNames2 = {}, _defineProperty(_classNames2, styles.top, true), _defineProperty(_classNames2, styles.arch, true), _defineProperty(_classNames2, styles[color], true), _classNames2)),
    classes: {
      circle: styles.circle
    },
    size: archWidth,
    thickness: 1
  }));
};

Arch.propTypes = {
  /** The value of the Arch */
  value: _propTypes.default.number.isRequired,

  /** The available colors of the Arch */
  color: _propTypes.default.oneOf(["error", "success", "warning"])
};
Arch.defaultProps = {
  color: "error"
};
var archColors = ["error", "success", "warning"];
exports.archColors = archColors;
var _default = Arch;
exports.default = _default;